// extracted by mini-css-extract-plugin
module.exports = {"btn":"menubtn_btn__2SJSk"};